<template>
  <div
    v-if="isVisible"
    class="o-flex -alignCenter t-noWrap s-chip">
    <SvgIcon
      type="info"
      :medium="!small"
      :small="small" />
    <div
      class="t-fontWeightMedium u-marginLeft1"
      :class="{ 't-caption1': !small, 't-caption2': small }">
      {{ daysLeft === 0 ? $tc('generic.ending_today') : $tc('generic.x_days_left', daysLeft, { days: daysLeft }) }}
    </div>
  </div>
</template>

<script>
import { differenceInCalendarDays } from 'date-fns'

import DateManager from '@/logic/DateManager'

export default {
  props: {
    endDate: {
      type: [Date, String],
      default: null,
    },
    maxDays: {
      type: Number,
      default: 6,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    daysLeft() {
      const parsedEndDate = typeof this.endDate === 'string' ? DateManager.parseModelDate(this.endDate) : this.endDate
      return differenceInCalendarDays(parsedEndDate, new Date())
    },
    isVisible() {
      if (this.daysLeft < 0) {
        return false
      }
      if (this.maxDays && this.daysLeft > this.maxDays) {
        return false
      }
      return true
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/config';

.s-chip {
  border-radius: $spacing-1;
  padding: 2px $spacing-1;
  color: $color-white;
}
</style>
